import Vue from 'vue';

export default {
    createAccount({ payload, token }) {
        const path = 'auth0/v2/user';
        const options = getOptionsWithToken(token);
        return Vue.axios.post(path, payload, options);
    },
    fetchPersonalDetails({ customerId, token }) {
        const path = `customer/${customerId}`;
        const options = getOptionsWithToken(token);
        return Vue.axios.get(path, options);
    },
    findCustomer({ email, token }) {
        const path = 'auth0/v2/user-by-email';
        const params = { email };
        const options = getOptionsWithToken(token, { params });
        return Vue.axios.get(path, options);
    },
    getEmailVerified({ token }) {
        const path = 'auth0/v2/user/verified';
        const options = getOptionsWithToken(token);
        return Vue.axios.get(path, options);
    },
    impersonateCustomer({ payload, token }) {
        const path = 'customer/impersonate';
        const options = getOptionsWithToken(token);
        return Vue.axios.post(path, payload, options);
    },
    requestPasswordReset({ email }) {
        const path = `https://chapmanauto.us.auth0.com/dbconnections/change_password`;
        const payload = {
            client_id: 'm6155vpmigWEx1wPwQpJMn7vLdL7Kffe',
            connection: 'MyChapman-Users',
            email,
        };
        return Vue.axios.post(path, payload);
    },
    resendVerificationEmail({ userId }) {
        const path = 'auth0/v2/jobs/verification-email';
        const payload = { user_id: userId };
        return Vue.axios.post(path, payload);
    },
};

function getOptionsWithToken(token, options = {}) {
    return {
        ...options,
        headers: {
            Authorization: `Bearer ${token}`,
        },
    };
}
